import { isGlobalFeatureEnabled } from 'owa-feature-flags';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Need import here to export wrapper
import React, { useState } from 'react';

export function useOwaState<S>(
    initialState: S | (() => S)
): [S, React.Dispatch<React.SetStateAction<S>>];
export function useOwaState<S>(
    initialState: S | (() => S),
    shouldUseTransition: boolean
): [S, React.Dispatch<React.SetStateAction<S>>];
export function useOwaState<S = undefined>(): [
    S | undefined,
    React.Dispatch<React.SetStateAction<S | undefined>>
];

export function useOwaState<S>(initialState?: S | (() => S), shouldUseTransition: boolean = false) {
    const [state, setState] = useState(initialState);
    const wrappedSetState = React.useCallback((newVal: React.SetStateAction<S | undefined>) => {
        React.startTransition(() => setState(newVal));
    }, []);
    if (isGlobalFeatureEnabled('fwk-useStateTransition-v2') && shouldUseTransition) {
        return [state, wrappedSetState];
    } else {
        // eslint-disable-next-line owa-custom-rules/no-unused-react-set-state -- Wrapper function necessitates passing
        return [state, setState];
    }
}
